import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { CssBaseline, Grid, Typography } from "@mui/material";
import HeroSection from "../../elements/HeroSection";
import ReviewsV2FormFrame from "./ReviewsV2FormFrame";
import ReviewsV2ListFrame from "./ReviewsV2ListFrame";
import { Box, useMediaQuery } from "@mui/system";
import theme from "../../elements/Theme";
import ReviewsJsonLd from "../../utils/ReviewsJsonLd";
import { RawReviews } from "../../utils/buildReviewsSchema";

const ReviewsV2Page: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const formRef = useRef<HTMLFormElement | null>(null);
  const reviews = t("ReviewsV2Frame.reviews", { returnObjects: true }) as unknown as RawReviews;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ReviewsJsonLd
        reviews={reviews}
      />
      <CssBaseline />
      <HeroSection
        mainTitle={<>{t("ReviewsPage.mainTitle")}</>}
        secondaryTitle={<>{t("ReviewsPage.secondaryTitle")}</>}
        backgroundImageUrl={"/enrollPage/hero.webp"}
        altImage={t("AltImages.alt_image_enroll")}
        buttonText={t("ReviewsPage.buttonText")}
        formRef={formRef}
      />
      <Box
        sx={{
          backgroundColor: "#ff5bb60d",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: isMobile ? "5vh" : "10vh",
        }}
      >
        <ReviewsV2FormFrame formRef={formRef} />
      </Box>

      <ReviewsV2ListFrame />

    </>
  );
};

export default ReviewsV2Page;
